import { Component, ElementRef, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from "../../service/app.layout.service";
import { ConfigUtils } from 'src/app/utils/config.utils';
import { AuthTokenService } from 'src/app/services/auth.token.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrl: './app.topbar.component.scss'
})
export class AppTopBarComponent {

    items!: MenuItem[];
    lightMode: boolean = false

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

    @ViewChild('topbarmenu') menu!: ElementRef;

    constructor(
        private router: Router,
        public layoutService: LayoutService,
        private authTokenService: AuthTokenService
    ) {
        this.lightMode = this.layoutService.config().theme == 'mdc-light-indigo'
    }

    swapTheme(lightMode: boolean) {
        this.lightMode = lightMode

        this.layoutService.config.update((config) => ({
            ...config,
            theme: lightMode ? 'mdc-light-indigo' : 'mdc-dark-indigo',
            colorScheme: lightMode ? 'light' : 'dark'
        }));

        ConfigUtils.setLightMode(lightMode)
    }

    onExitClick() {
        this.authTokenService.removeAuth()
        this.router.navigate(['/base/login'])
    }
}
